import { render } from "./HomeView.vue?vue&type=template&id=9f73e5f4&scoped=true"
const script = {}

import "./HomeView.vue?vue&type=style&index=0&id=9f73e5f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f73e5f4"]])

export default __exports__